import React from 'react'
import { Navbar, Nav} from 'react-bootstrap'
import '../App.css'
import WorkRoundedIcon from '@material-ui/icons/WorkRounded';
import CodeRoundedIcon from '@material-ui/icons/CodeRounded';
import AssessmentRoundedIcon from '@material-ui/icons/AssessmentRounded';
import PersonIcon from '@material-ui/icons/Person';

export const Header = () => {

    const path = window.location.href.toString().split('/')[window.location.href.toString().split('/').length-1]

    const styleNavbar={
        padding:'0.5% 2%',
        backgroundColor:'rgb(31,31,31)',
        borderBottom:"0.2px solid rgb(52,52,52)"
    }

    const styleNavLink={
        alignItems:'center',
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        // color:"rgb(168,168,168)"
    }

    const styleNavLinkActive={
        alignItems:'center',
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        color:'white'
    }

    const styleBrand={
        fontWeight:600,
        fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI,Roboto, Oxygen, Ubuntu, Cantarell,Open Sans,Helvetica Neue,sans-serif',
        fontSize:30
     }

    return (
        <>
            <Navbar 
                style={styleNavbar} 
                expand='lg' 
                variant='dark' 
                collapseOnSelect 
                fixed="top" 
                >
                <Navbar.Brand href='/'>
                    <b style={styleBrand}>{"<Au/>"}</b>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" >
                    <Nav className="mr-auto"></Nav>
                    <Nav className="mr-auto"></Nav>
                    <Nav className="mr-auto"></Nav>
                    <Nav className="mr-auto">
                        <Nav.Link className='desk_nav' href="/" style={path==='' ? {...styleNavLinkActive, color:"rgb(66,135,245)"} : styleNavLink}>
                        <PersonIcon  className='mr-1'/>
                            Home
                        </Nav.Link>
                    </Nav>
                    <Nav className="mr-auto">
                        <Nav.Link className='desk_nav' href="/qualification" style={path==='qualification' ? {...styleNavLinkActive,color:"rgb(255,180,0)"} : styleNavLink}>
                            <AssessmentRoundedIcon className='mr-1'/>
                            Qualification
                        </Nav.Link>
                    </Nav>
                    <Nav className="mr-auto">
                        <Nav.Link className='desk_nav' href="/projects" style={path==='projects' ? {...styleNavLinkActive,color:"rgb(252,3,173)"} : styleNavLink}>
                            <CodeRoundedIcon className='mr-1'/>
                            Projects
                        </Nav.Link>
                    </Nav>
                    <Nav>
                        <Nav.Link className='desk_nav' href="/hire" style={path==='hire' ? {...styleNavLinkActive, color:"rgb(0,191,25)"} : styleNavLink} >
                            <WorkRoundedIcon className='mr-1' />
                            Hire me
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    )
}
